import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KuiCheckbox } from './checkbox.directive';

@NgModule({
  imports: [CommonModule],
  exports: [KuiCheckbox],
  declarations: [KuiCheckbox],
})
export class KuiCheckboxModule {}
